module.exports = __webpack_public_path__ + "img/logo_150px_grey.b035d118.png";